<template>
  <ZigzagServiceLayout
    mainTitle="Reparo do Lóbulo da Orelha e Remodelação"
    mainDescription="Oferecemos procedimentos simples e seguros projetados para melhorar a aparência e a simetria, e reparar os lóbulos da orelha sem cirurgia tradicional."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EarLobeRepairContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ESTÉTICA E REPARO',
          title: 'Benefícios e Técnicas',
          subtitle: 'Restaurando a forma de maneira natural e segura.',
          paragraphs: [
            "Utilizamos técnicas de otomodelação não cirúrgicas para ajudar pacientes com lóbulos rasgados ou assimétricos. Seja por brincos pesados ou irregularidades naturais, restauramos o volume.",
            "Usando preenchimentos dérmicos, fios PDO ou rejuvenescimento com PRP, levantamos suavemente, corrigimos ângulos e restauramos a elasticidade da pele sem as cicatrizes da cirurgia."
          ],
          list: [
            "Preenchedores Dérmicos para restaurar a forma",
            "Fios PDO/PLLA para levantamento não invasivo",
            "Rejuvenescimento com PRP para elasticidade",
            "Perfeito para lóbulos esticados ou orelhas proeminentes"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/9rbA47bOvms'
          ]
        },
        {
          label: 'PROCEDIMENTO',
          title: 'Detalhes do Procedimento',
          subtitle: 'Rápido, seguro e confortável.',
          paragraphs: [
            "Nossos tratamentos são realizados no consultório com anestesia local para garantir o seu conforto. A aplicação produz resultados imediatos e satisfatórios.",
            "Você pode esperar uma recuperação rápida com apenas um leve inchaço que desaparece em 24 a 48 horas. Também oferecemos a remoção segura de pequenos cistos."
          ],
          list: [
            "Anestesia local aplicada para total conforto",
            "Resultados imediatos com contornos equilibrados",
            "Recuperação rápida (inchaço leve por 24-48h)",
            "Remoção segura de pequenos cistos disponível"
          ],
          image: '/images/services/earlobe-repair.png'
        }
      ]
    };
  }
};
</script>
